import { useEffect } from 'react';

import { ENV } from '../config/env';

const INSIGHT_SCRIPT_SRC = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';

const loadInsightTag = (partnerId: string): (() => void) => {
  const partnerScript = document.createElement('script');
  partnerScript.type = 'text/javascript';
  partnerScript.text = `
    _linkedin_partner_id = "${partnerId}";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(_linkedin_partner_id);
  `;
  document.body.appendChild(partnerScript);

  if (!window.lintrk) {
    const lintrk = ((action: string, data?: unknown) => {
      lintrk.q.push([action, data]);
    }) as NonNullable<Window['lintrk']>;
    lintrk.q = [];
    window.lintrk = lintrk;
  }

  const insightScript = document.createElement('script');
  insightScript.type = 'text/javascript';
  insightScript.async = true;
  insightScript.src = INSIGHT_SCRIPT_SRC;
  document.body.appendChild(insightScript);

  return () => {
    partnerScript.remove();
    insightScript.remove();
  };
};

export const LinkedInInsightTag = () => {
  const partnerId = ENV.LINKEDIN_PARTNER_ID?.trim();
  const isProduction = ENV.APP_ENV === 'prd';

  useEffect(() => {
    if (!isProduction || !partnerId) {
      return;
    }

    return loadInsightTag(partnerId);
  }, [isProduction, partnerId]);

  if (!isProduction || !partnerId) {
    return null;
  }

  return (
    <img
      height="1"
      width="1"
      style={{ display: 'none' }}
      alt=""
      src={`https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif`}
    />
  );
};
